// extracted by mini-css-extract-plugin
export default {"container":"ItemsList_container__zJPx5","title":"ItemsList_title__28Cw8","itemsListContainer":"ItemsList_itemsListContainer__ApllF","multiLine":"ItemsList_multiLine__3tpQU"};